module.exports = __webpack_public_path__ + "static/media/logout.b1e73d35.svg";